import { atom, useAtom } from "jotai";

const teamIdAtom = atom<string | undefined>(undefined);

export const useTeamIdAtom = () => {
  return useAtom(teamIdAtom);
};
